import { render, staticRenderFns } from "./ViewLeaveRequest.vue?vue&type=template&id=87fdfda8&scoped=true"
import script from "./ViewLeaveRequest.vue?vue&type=script&lang=js"
export * from "./ViewLeaveRequest.vue?vue&type=script&lang=js"
import style0 from "./ViewLeaveRequest.vue?vue&type=style&index=0&id=87fdfda8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fdfda8",
  null
  
)

export default component.exports